<template>
  <dialog-add
    icon="hub"
    :title="$t('new_network')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
  >
    <template v-slot:content>
      <forms-tracking-network
        :on-cancel="onCancel"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/tracking-networks');
    },
  },
};
</script>
